/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {message} from 'antd'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class PersonReson extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reason: [],
      printInfo: [],
      lengthReson: 0,
      pageNumber: 1,
      modalDelete: false,
      modalEdit: false
    }
  }

  getPersonReason = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            reason: response.data.object.result,
            lengthReson: response.data.object.countAll
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('params', '')
    this.getPersonReason()
  }

  onResultFetched(data) {
    this.setState({
      reason: data
    })
  }

  changeDropDown(data) {
    this.setState({
      reason: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  activate = (numRow) => {
    let status = this.state.reason[numRow].enabled
    if (status) {
      let id = this.state.reason[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_DISABLE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getPersonReason()
          } else {
            message.error('عملیات تغییر وضعیت دلیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.reason[numRow].id
      let data = {
        id: id
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_ENABLE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getPersonReason()
          } else {
            message.error('عملیات تغییر وضعیت دلیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteReason = (numId) => {
    let resonId = this.state.reason[numId].id
    let reasonName = this.state.reason[numId].name
    sessionStorage.setItem('reasonId', resonId)
    sessionStorage.setItem('reasonName', reasonName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('reasonId')
    sessionStorage.removeItem('reasonName')
  }

  deleteOk = () => {
    let reasonId = sessionStorage.getItem('reasonId')
    let data = {
      id: reasonId
    }
    http
      .post(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_DELETE}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          this.getPersonReason()

          message.success('دلیل با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  editReason = (numId) => {
    let resonId = this.state.reason[numId].id
    let reasonName = this.state.reason[numId].name
    let typeName = this.state.reason[numId].type
    sessionStorage.setItem('resonId', resonId)
    sessionStorage.setItem('reasonName', reasonName)
    sessionStorage.setItem('typeName', typeName)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }
  EditCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.removeItem('reasonId')
    sessionStorage.removeItem('reasonName')
    sessionStorage.removeItem('typeName')
  }
  EditOk = () => {
    let resonId = sessionStorage.getItem('resonId')
    var name = document.getElementById('name').value
    var type = document.getElementById('type').value
    var nameError = false
    var typeError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام دلیل وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      type = true
      message.error('نوع دلیل کاربر را وارد کنید')
    } else {
      if (!type) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        personReasonId: resonId,
        name: name,
        type: type
      }

      // alert(JSON.stringify(data))
      http
        .post(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_EDIT}`, data)
        .then((response) => {
          if (response.data.error == null) {
            this.getPersonReason()

            message.success('دلیل کاربر ویرایش شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  getPrintInfo = () => {
    http
      .get(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT}?export=true`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT}?export=true`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error === null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }

            if (excelReport[i]['type'] == '-1') {
              excelReport[i]['type'] = 'عمومی'
            } else {
              excelReport[i]['type'] = ''
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reasonName = sessionStorage.getItem('reasonName')
    let typeName = sessionStorage.getItem('typeName')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let excelColumns = [{title: 'عنوان', value: 'name'}, {title: 'نوع', value: 'type'}]
    let name = cookie.load('name')
    let columns = ['ردیف', 'عنوان', 'نوع ', 'وضعیت فعال']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header=" لیست دلایل تغییر حالت کاربر"
              headerColSpan={4}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((reason, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{reason.name}</td>
                  <td>{reason.type == '-1' ? 'عمومی' : ''}</td>
                  <td>{reason.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="دلایل تغییر حالت کاربر.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'type'}
                field={'type'}
                title={'نوع'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>کاربران</li>
            <li>دلایل تغییر حالت کاربر</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="addPersonReason"
                  printUrl=""
                  url={USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن دلیل کاربر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>

                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <table className="baseTable">
              <tr className="firstRow">
                <td>ردیف</td>
                <td>عنوان</td>
                <td>نوع</td>
                <td>وضعیت فعال</td>
                <td>ویرایش</td>
                <td>حذف</td>
              </tr>
              {this.state.reason.map((reason, index) => (
                <tr key={index}>
                  <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                  <td>{reason.name}</td>
                  <td>{reason.type == '-1' ? 'عمومی' : ''}</td>
                  <td>
                    <button onClick={() => this.activate(index)}>
                      {reason.enabled ? (
                        <img src={require('../../image/on.svg')} alt="" />
                      ) : (
                        <img src={require('../../image/off.svg')} alt="" />
                      )}
                    </button>
                  </td>
                  <td>
                    <button onClick={() => this.editReason(index)}>
                      <img src={require('../../image/editDriver.svg')} alt="" />
                    </button>
                  </td>
                  <td>
                    <button onClick={() => this.deleteReason(index)}>
                      <img src={require('../../image/trash.svg')} alt="" />
                    </button>
                  </td>
                </tr>
              ))}
            </table>
            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthReson}
                onResultFetched={this.onResultFetched.bind(this)}
                url={USER_MANAGE.USER_MANAGE_BASE_STATEREASON_REPORT}
              />
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف دلیل</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف دلیل {reasonName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف دلیل
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="sm">
            <ModalHeader toggle={this.EditCancel}>ویرایش {reasonName}</ModalHeader>
            <ModalBody>
              <div className="modalForm">
                <div className="formComponent">
                  <label>نام دلیل کاربر (الزامی)</label>
                  <input type="text" defaultValue={reasonName} id="name" className="form-control" />
                </div>

                <div className="formComponent">
                  <label>نوع (الزامی)</label>
                  <select className="form-control" name="type" defaultValue={typeName} id="type">
                    <option value="">نوع را مشخص کنید</option>
                    <option value="-1" selected={true}>
                      عمومی
                    </option>
                  </select>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk}>
                ویرایش دلیل
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default PersonReson
